import { Component, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { FormControl, Validators } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from '@kodit/core/shared-ui';
import {
  GetPackagesContractQuery,
  PaketiClient,
  UpdateUserPackagesCommand,
} from '@kodit/core/data-api';
import { finalize } from 'rxjs/operators';
import {
  AlertService,
  AuthGuard,
  AuthService,
  SharedService,
} from '@kodit/core/services';

@Component({
  selector: 'kodit-uslovi-ugovora-dialog',
  templateUrl: './uslovi-ugovora-dialog.component.html',
  styleUrls: ['./uslovi-ugovora-dialog.component.scss'],
})
export class UsloviUgovoraDialogComponent implements OnDestroy {
  /** Subs */
  private _subs: Subscription = new Subscription();

  /** Forms */
  zastupniciCtrl: FormControl;

  /** Props */
  termsAccepted: boolean = false;

  constructor(
    private _dialogConfig: DynamicDialogConfig,
    private _sharedService: SharedService,
    private _paketiClient: PaketiClient,
    private _dialogRef: DynamicDialogRef,
    private _alert: AlertService,
    private _authService: AuthService,
    private _authGuard: AuthGuard
  ) {
    this.zastupniciCtrl = new FormControl(this._dialogConfig.data.zastupnici, {
      validators: [Validators.required],
    });
  }

  save() {
    if (this.zastupniciCtrl.invalid) {
      this.zastupniciCtrl.markAsDirty();
      return;
    }

    this._sharedService.displayLoadingScreen(true, 'Čuvanje u toku...');
    this._subs.add(
      this._paketiClient
        .updatePackages({
          odabirPaketaDto: this._dialogConfig.data.paketi,
          zastupnik: this.zastupniciCtrl.value,
        } as UpdateUserPackagesCommand)
        .pipe(
          finalize(() => {
            this._sharedService.resetLoadingScreen();
          })
        )
        .subscribe(async (res) => {
          const success = await this._authGuard.tryRefreshingTokens();
          if (success) {
            this._authService.notifyPackagesChanged();
            this._alert.addSuccessMsg(res.data);
            this._dialogRef.close(true);
          }
        })
    );
  }

  downloadContractPreview() {
    if (this.zastupniciCtrl.invalid) {
      this.zastupniciCtrl.markAsDirty();
      return;
    }

    this._sharedService.displayLoadingScreen(
      true,
      'Generisanje ugovora u toku...'
    );
    this._subs.add(
      this._paketiClient
        .getContract({
          dto: this._dialogConfig.data.paketi,
          zastupnik: this.zastupniciCtrl.value,
        } as GetPackagesContractQuery)
        .pipe(
          finalize(() => {
            this._sharedService.resetLoadingScreen();
          })
        )
        .subscribe((res) => {
          const blob = res.data;

          const url = URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = res.fileName;
          a.click();

          URL.revokeObjectURL(url);
        })
    );
  }

  ngOnDestroy(): void {
    this._subs.unsubscribe();
  }
}
